export default __webpack_public_path__ + "static/media/CourseThumbnail-Crossfit01.a129c7a5.png";